/**
 * EventCreatedByRow
 *
 * Displays the event organizer/creator.
 * Read-only row showing who created the event.
 */

import { StyleSheet, Text, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Colors } from '@/constants/theme';
import { Spacing } from '@/constants/spacing';
import { getBodyFont } from '@/constants/typography';

type EventCreatedByRowProps = {
  organizer: { email?: string; name?: string | null } | null;
  palette: typeof Colors.light;
};

export function EventCreatedByRow({ organizer, palette }: EventCreatedByRowProps) {
  const displayName = organizer?.name ?? organizer?.email ?? 'Unknown';

  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <Ionicons name="person-outline" size={18} color={palette.textMuted} />
      </View>
      <View style={styles.content}>
        <Text style={[styles.label, { color: palette.textMuted, fontFamily: getBodyFont() }]}>
          Created by
        </Text>
        <Text
          style={[styles.value, { color: palette.text, fontFamily: getBodyFont() }]}
          numberOfLines={1}
        >
          {displayName}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    paddingHorizontal: Spacing.lg,
    paddingVertical: Spacing.sm + 2, // 10px
  },
  iconContainer: {
    width: 40,
    alignItems: 'center',
    paddingTop: Spacing.xs,
  },
  content: {
    flex: 1,
    gap: 2,
  },
  label: {
    fontSize: 14,
  },
  value: {
    fontSize: 14,
  },
});
